import useSharedGenrePageContext from '../common/hooks/useSharedGenrePageContext';
import useGenre from '../common/hooks/useGenre';
import useGenreShows from '../common/hooks/useGenreShows';
import GenreHeaderMobile from './GenreHeaderMobile';
import GenreInfoMobile from './GenreInfo';
import { size } from '@/helpers/lodash';
import PageHeader from '@/components/app/PageHeader';
import LayoutWrapperVertical from '@/components/component-library/LayoutWrapperVertical';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import ShowPreviewGrid from '@/components/app/ShowPreviewGrid';
import { streamingContextTypes } from '@/config/events-keakie';
import useInitialRender from '@/hooks/browser/useInitialRender';

const GenrePageMobile = () => {
  const { isFirstRender } = useInitialRender();
  const { onClickChannel } = useSharedGenrePageContext();
  const {
    genre,
    parentGenre,
    isLoading
  } = useGenre();
  const {
    shows: genreShows,
    isLoading: showsLoading,
    isError: showsError
  } = useGenreShows();

  const { description, id: genreId } = genre;
  const { title: parentTitle } = parentGenre;

  return (
    <div className='mob__genre-page'>
      <PageHeader>
        <GenreHeaderMobile
          parentTitle={ parentTitle }
          subgenreOptionsLoading={ isFirstRender }
        />
      </PageHeader>
      <LayoutWrapperVertical
        disableTopOnMobile
        extraPagePadding
      >
        <LayoutWrapperHorizontal className='mob__genre-content'>
          <GenreInfoMobile
            description={ description }
            loading={ !description }
            showsCount={ size(genreShows) }
            showsCountLoading={ showsLoading || isLoading }
          />
          { !showsError && !(!showsLoading && !size(genreShows)) && (
          <ShowPreviewGrid
            channels={ genreShows }
            className='mob__genre-shows-grid-wrapper'
            id={ genreId }
            loading={ showsLoading }
            onClickChannel={ onClickChannel }
            streamingContext={ streamingContextTypes.GENRE_SHOW_SLATE }
          />
          ) }
        </LayoutWrapperHorizontal>
      </LayoutWrapperVertical>
    </div>
  );
};

export default GenrePageMobile;